import { Link } from "react-router-dom";
import Header from "../../../components/header/Header";

const Index = () =>{
    return(
        <div>
            <Header headerTitle="서류제출" arrowYn={false} closeYn={false}/> 
            <div id="container">		
                <div className="content">
                    <div className="wrapBoxPd bottomGnbShow">
                        <div className="titleWrap">
                            <div className="bigTit">
                                서류 제출을 위해서는<br/>
                                PC에서 최초 1회<br/>
                                공동인증서 등록이 필요합니다.
                            </div>
                            <div className="normalTit mt24 txtKeepall">
                                PC에서 doc.ibkbox.net으로
                                접속하신 후
                                서류 제출을 다시 진행해 주세요.
                            </div>	
                        </div>
                        <div className="mt40">
                            <div className="ImgWrap">
                                <div className="img CM5000-4"></div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="fullbtn">
                    <Link to="/"className="btn on">확인</Link>
                </div>
            </div>
        </div>
    );
}
export default Index;